import { useRef, useCallback, useEffect } from "react";
function useFocusManagement({
  isOpen,
  overlayRef,
  restoreFocusDelay = 0,
  shouldMount,
  shouldRestoreFocus = true
}) {
  const previouslyFocusedElementRef = useRef(null);
  const handleFocusTrap = useCallback(() => {
    var _a;
    const overlay = overlayRef.current;
    if (overlay) {
      const focusableElements = overlay.querySelectorAll(
        'a[href], button, textarea, input, select, [tabindex]:not([tabindex="-1"])'
      );
      (_a = focusableElements[0]) == null ? void 0 : _a.focus();
    }
  }, [overlayRef]);
  const restoreFocus = useCallback(() => {
    var _a;
    (_a = previouslyFocusedElementRef.current) == null ? void 0 : _a.focus();
  }, []);
  useEffect(() => {
    if (!shouldMount)
      return;
    if (isOpen) {
      if (shouldRestoreFocus) {
        previouslyFocusedElementRef.current = document.activeElement;
      }
      setTimeout(handleFocusTrap, 50);
    } else if (shouldRestoreFocus) {
      setTimeout(restoreFocus, restoreFocusDelay + 50);
    }
  }, [isOpen, handleFocusTrap, restoreFocus, restoreFocusDelay, shouldMount, shouldRestoreFocus]);
}
export {
  useFocusManagement
};
